import { Box, TextField } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export default function InputText(props) {
  const {
    value,
    name,
    onChangeField,
    label,
    multiline = false,
    rows = 1,
    ...rest
  } = props;

  return (
    <>
      <Box
        sx={{
          width: 170,
          fontWeight: "bold",
          display: "flex",
          marginBottom: "10px",
        }}
      >
        {label}
      </Box>
      <TextField
        id={`${name}-filed`}
        InputLabelProps={{ shrink: true }}
        value={value}
        onChange={onChangeField}
        name={name}
        size="small"
        sx={{
          width: "100%",
          borderRadius: "4px",
        }}
        variant="outlined"
        required
        multiline={multiline}
        rows={rows}
        autoComplete="new-input"
        {...rest}
      />
    </>
  );
}

InputText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  multiline: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rows: PropTypes.number,
  onChangeField: PropTypes.func.isRequired,
};
InputText.defaultProps = {
  multiline: false,
  rows: 1,
};
